import Fieldset from 'components/form/fieldset'
import Field from 'components/custom_fields/field'

const CustomFields = ({ fields = [], onChange }) => {
  if (!fields.length) return null

  return (
    <Fieldset>
      {
        fields.map(({
          id, format, name, required, value, answer_choices: answers, include_other: includeOther
        }, index) => (
          <Field
            key={id}
            index={index}
            format={format}
            name={name}
            required={required}
            value={value}
            answers={answers}
            includeOther={includeOther}
            onChange={onChange}
          />
        ))
      }
    </Fieldset>
  )
}

export default CustomFields
